export default "__VITE_ASSET__218bf53e__"